import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Country, CountryService, Profile, UserService } from 'octali-lib-firebase-utils';
import { Address, AddressService, Cart, Shipping, ShippingService } from 'octali-lib-shop';
import { combineLatest, Subscription } from 'rxjs';

@Component({
  selector: 'app-shipping-cart-detail-view',
  templateUrl: './shipping-cart-detail-view.component.html',
  styleUrls: ['./shipping-cart-detail-view.component.scss'],
})
export class ShippingCartDetailViewComponent implements OnInit, OnDestroy {

  @Input() cart: Cart;
  @Input() total: number = 0;
  @Output() selectShipping = new EventEmitter<number>();
  @Output() loginAction = new EventEmitter<boolean>();
  @Output() setAddressAction = new EventEmitter<boolean>();
  @Output() shippingCost = new EventEmitter<number>();

  public profile:Profile;
  public address:Address;
  public shippings:Array<Shipping>;
  private subscription:Subscription;
  public shippingMode:any;
  public shipping;
  public countriesByCode:Map<string,Country>;

  constructor(
    private addressService: AddressService,
    private shippingService: ShippingService,
    private countryService: CountryService,
    private profileService: UserService
  ) { 
    console.log("Coucou");
    
  }

  public reset(){
    this.shipping = null;
    this.shippingMode = null
  }

  ngOnInit(): void {
  console.log("INIT");
  this.subscription = combineLatest([
    this.addressService.getAddressObs(),
    this.shippingService.getShippingsByCountryObs(),
    this.countryService.getCountriesByCode(),
    this.profileService.getUser()
  ]).subscribe( ([address,shippings, countries, profile]) => {
    console.log("INIT2");
    //if( address && shippings && countries && profile){
      if( address )
        this.address = address;
      if( profile )
        this.profile = profile;
      if( shippings && this.address )
        this.shippings = shippings.get(address.country);
      if( countries )
        this.countriesByCode = countries;
      console.log("PROFILE",profile);
      console.log("ADDRESS",address);
      
      console.log("COUNTRIES",countries);
      console.log("SHIPPINGS",this.shippings);
    //}
  });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  setCart(cart:Cart){
    this.cart = cart;
  }
  
  getPrice(shipping:Shipping){
    if(this.cart){
      let price:number = 0;
      switch(shipping.mode){
        case "price":
          if(shipping.freeStep >0 && this.total>shipping.freeStep)
            price = 0;
          else{
            price += shipping.fixedCost;
            let priceT = 0;
            for(let step of shipping.costSteps){
              if(this.total < step[0])
                priceT = step[1];
              else
                break;
            }
            price += priceT;
          }
          break;
        case "weight":
          if(shipping.freeStep > 0 && this.total>shipping.freeStep)
            price = 0;
          else{
            price += shipping.fixedCost;
          }
          break;
      }
    if(price == 0){
      this.shippingCost.emit(0);
      return "offert";
    }
    else{
      this.shippingCost.emit( price );
      return price.toFixed(2) +" €";
    }
    }else {
      this.shippingCost.emit( 0 );
      return "---";
    }
  }

  shippingModeSelected(shipping) {
    this.selectShipping.emit(shipping.detail.value);
  }

  moreFreeShipping(shipping:Shipping) :string {
    return (shipping.freeStep - this.total).toFixed(2);
    
  }

  login($event){
    this.loginAction.emit(true);
  }

  setAddress($event){
    this.setAddressAction.emit(true);
  }

}
